import { createIcon } from '../createIcon';

export const GreaterThanEqualIconConfig = {
  name: 'GreaterThanEqualIcon',
  height: 512,
  width: 448,
  svgPath: 'M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const GreaterThanEqualIcon = createIcon(GreaterThanEqualIconConfig);

export default GreaterThanEqualIcon;